import { isPathSameAsRoute } from '../route';
import { safeWindow } from '../safeWindow';
import {
  APP_ROUTE_STORAGE_KEY,
  APP_STATE_STORAGE_KEY,
  RawStorageItems,
} from './storage.type';

export const storage = safeWindow()?.sessionStorage;

export function retrieveFromStorage(): RawStorageItems {
  const state = storage?.getItem(APP_STATE_STORAGE_KEY) ?? null;
  const route = storage?.getItem(APP_ROUTE_STORAGE_KEY) ?? null;

  return {
    state,
    route,
  };
}

export function parseState(): Record<string, unknown> {
  try {
    const { state } = retrieveFromStorage();

    return state ? (JSON.parse(state) as Record<string, unknown>) : {};
  } catch (_error) {
    return {};
  }
}

export function parseRetrievedState<TState = unknown>(): TState | null {
  const { state, route } = retrieveFromStorage();

  if (!state || !route) {
    return null;
  }

  try {
    const stateMachine = JSON.parse(state) as TState;

    if (isPathSameAsRoute(route)) {
      return stateMachine;
    }

    return null;
  } catch (err) {
    return null;
  }
}

export function saveStateToStorage(
  state: unknown,
  currentPath: string | undefined,
): void {
  const jsonState = JSON.stringify(state);

  try {
    storage?.setItem(APP_STATE_STORAGE_KEY, jsonState);
    storage?.setItem(APP_ROUTE_STORAGE_KEY, currentPath ?? '');
  } catch (error) {
    console.error(error);
  }
}

export function removeStateFromStorage(): void {
  try {
    storage?.removeItem(APP_STATE_STORAGE_KEY);
    storage?.removeItem(APP_ROUTE_STORAGE_KEY);
  } catch (error) {
    console.error(error);
  }
}
